import { useContext, useState } from 'react';
import { AppState } from '../context/general';
import { TextButton } from 't-lib-ui/widgets';
import FeedIssueIcon from './FeedIssueIcon';
import './FeedLoadError.css';

// Shown when the feed engine failed to load the library (server error — offline is handled
// separately with retries). The empty-feed UIs must NEVER render in this case: a user who sees
// "no feeds"/the new-user welcome after a 500 believes their subscriptions are gone.
// compact renders a slim variant for the sidebar's feed-list slot.
const FeedLoadError: React.FC<{ compact?: boolean }> = ({ compact }) => {
    const appState = useContext(AppState);
    const [retrying, setRetrying] = useState(false);
    // enable() from ERROR does a clean-slate reload; state flips to LOADING and the
    // useEngineState subscribers swap this panel back for the normal loading UI.
    const retry = async () => {
        setRetrying(true);
        try { await appState.feedEngine.enable(appState.state.authData); }
        finally { setRetrying(false); }
    };

    if (compact)
        return (
            <div className="feedLoadError feedLoadErrorCompact">
                <span><FeedIssueIcon size={14} /> Feeds couldn't be loaded</span>
                <button className="feedLoadErrorRetry" onClick={retry}>{retrying ? 'Retrying…' : 'Try again'}</button>
            </div>
        );
    return (
        <div className="feedLoadError">
            <FeedIssueIcon size={40} />
            <h2>Your feeds couldn't be loaded</h2>
            <p>Something went wrong on our side. Please try again in a moment.</p>
            <TextButton label={retrying ? 'Retrying…' : 'Try again'} type="major" onClick={retry} />
        </div>
    );
};

export default FeedLoadError;
